'use strict';

/**
 * @param {*} argument
 * @returns {*}
 */
export function identity(argument) {
  return argument;
}
/**
 * @returns {Boolean}
 */
export const {isArray} = Array;
/**
 *
 */
export function noop() {}


// WEBPACK FOOTER //
// ./src/js/lang.js